import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {getInputClassName} from "../../../../../CommonFunctions";
import {ValuableItemWithStartDate, IClaimProperties} from "@falcon/services";

interface IState {
    itemType: string;
    description: string;
    itemPrice: string;
    isItemTypeValid: boolean;
    isDescriptionValid: boolean;
    isItemPriceValid: boolean;
    itemTypeValidationMessage: string;
    itemDescriptionValidationMessage: string;
    itemPriceValidationMessage: string;
}

interface IProps {
    showModal: boolean;
    onHide: () => void;
    onItemAdding?: (item: IClaimProperties, state: boolean) => void;
    onUpdate?: (item: IClaimProperties) => void;
    item?: ValuableItemWithStartDate;
}

export class ClaimItemModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            itemType: this.props.item ? this.props.item.valuableItemType.code : "",
            description: this.props.item ? this.props.item.description : "",
            itemPrice: this.props.item ? this.props.item.value.toString() : "",
            isItemTypeValid: true,
            isDescriptionValid: true,
            isItemPriceValid: true,
            itemTypeValidationMessage: "Please enter type of item",
            itemDescriptionValidationMessage: "Please enter description",
            itemPriceValidationMessage: "Please enter estimated replace value"
        };
    }

    public render() {
        return (
            <Modal className="my-2 add-new-item-modal" isOpen={this.props.showModal} toggle={this.handleModalHide}
                   backdrop="static">
                <ModalHeader toggle={this.handleModalHide}>
                    <div className="d-flex">
                        <div
                            className="text-blue-2 font-weight-medium">{this.props.item ? "Edit item" : "Add item"}</div>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className="form-group">
                        {!this.state.isItemTypeValid ? this.renderErrorMessage(this.state.itemTypeValidationMessage) :
                            <label htmlFor="typeOfItem" className="font-weight-semi-bold">Type of item, make,
                                model</label>}
                        <div className="input-group w-75">
                            <input type="text" className={getInputClassName(this.state.isItemTypeValid)}
                                   id="typeOfItem"
                                   value={this.state.itemType}
                                   onChange={this.handleChange} onClick={this.handleChange}/>
                        </div>
                    </div>
                    <div className="form-group">
                        {!this.state.isDescriptionValid ? this.renderErrorMessage(this.state.itemDescriptionValidationMessage) :
                            <label htmlFor="description" className="font-weight-semi-bold">Description</label>}
                        <div className="input-group w-75">
                            <input type="text" className={getInputClassName(this.state.isDescriptionValid)}
                                   id="description"
                                   value={this.state.description}
                                   onChange={this.handleChange} onClick={this.handleChange}/>
                        </div>
                    </div>
                    <div className="form-group mb-0">
                        {!this.state.isItemPriceValid ? this.renderErrorMessage(this.state.itemPriceValidationMessage) :
                            <label htmlFor="estimatedPrice" className="font-weight-semi-bold">Estimated replace
                                value</label>}

                        <div className="input-group w-50">
                            <span className="mt-2 mr-2"><b>£</b></span>
                            <input type="text" className={getInputClassName(this.state.isItemPriceValid)}
                                   id="estimatedPrice"
                                   value={this.state.itemPrice}
                                   maxLength={5}
                                   onChange={this.handleChange} onClick={this.handleChange}/>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="d-block">
                    <button type="button" className="btn btn-primary btn-next w-100"
                            onClick={this.props.item ? this.handleItemEdit : this.handleItemAdding}
                            disabled={!this.isFormValid()} id="claimItemButton">
                        {this.props.item ? "Update" : "Add item"}
                    </button>
                </ModalFooter>
            </Modal>
        );
    }

    private isFormValid = (): boolean => {
        return (this.state.description !== "" && this.state.itemType !== "" && this.state.itemPrice !== ""
            && this.state.isDescriptionValid && this.state.isItemTypeValid && this.state.isItemPriceValid);
    };

    private handleItemAdding = (event: any): void => {
        if (event.target.disabled) {
            event.preventDefault();
        } else {
            const item = {
                type: this.state.itemType,
                description: this.state.description,
                price: parseInt(this.state.itemPrice, 10)
            };

            this.props.onItemAdding!(item, false);
            this.resetState();
        }
    };

    private handleItemEdit = (event: any): void => {
        if (event.target.disabled) {
            event.preventDefault();
        } else {
            const item: any = {
                type: this.state.itemType,
                description: this.state.description,
                price: parseInt(this.state.itemPrice, 10),
                itemId: this.props.item!.valuableItemId
            };

            this.props.onHide();
            this.props.onUpdate!(item);
            this.resetState();
        }
    };

    private handleModalHide = (): void => {
        this.props.onHide();
        this.resetState();
    };

    private resetState = (): void => {
        this.setState({
            itemType: "", description: "", itemPrice: "",
            isItemPriceValid: true, isDescriptionValid: true, isItemTypeValid: true
        });
    };

    private handleChange = (event: any): void => {
        event.preventDefault();
        const {id, value} = event.target;
        const priceRegex: RegExp = /^[\d ]{1,5}$/;

        switch (id) {
            case "typeOfItem":
                this.setState({
                    itemType: value,
                    isItemTypeValid: value && value !== "",
                });
                break;
            case "description":
                this.setState({
                    description: value,
                    isDescriptionValid: value && value !== "",
                });
                break;
            case "estimatedPrice":
                this.setState({
                    itemPrice: value,
                    isItemPriceValid: value && priceRegex.test(value)
                });
                break;
            default:
                break;
        }
    };

    private renderErrorMessage = (message: string) => {
        return (<label className="text-red">{message}</label>)
    };
}
